<script lang="ts">
import { defineComponent, reactive, watch } from '@vue/composition-api';

interface IProps {
    isLoading: boolean;
    delay: number;
}

export default defineComponent<IProps>({
    name: 'AppPageLoader',
    props: {
        isLoading: Boolean,
        delay: { type: Number, default: 400 },
    },
    setup(props) {
        watch(
            () => props.isLoading,
            () => {
                if (props.isLoading) {
                    setTimeout(() => {
                        if (props.isLoading) {
                            state.showLoading = true;
                        }
                    }, props.delay);
                } else {
                    state.showLoading = false;
                }
            },
            { immediate: true }
        );

        const state = reactive({
            showLoading: false,
        });

        return {
            state,
        };
    },
});
</script>

<template>
  <div>
    <div v-if="isLoading">
      <template v-if="state.showLoading">
        <v-overlay :value="state.showLoading" z-index="101">
          <v-progress-circular indeterminate size="64" />
        </v-overlay>
      </template>
    </div>
    <slot v-else />
  </div>
</template>
